module.exports = __webpack_public_path__ + "img/cal.85db5d71.png";